/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import axios from 'axios';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { ApplicationFormPageService } from '../index';
import {
  GET_APPLICATION,
  GET_CSME,
  GET_MARRIAGE,
  GET_NWP,
  GET_RWP,
} from '@pages/ApplicationForm/api/graphql';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { workPermitConfig } from '../../config/workPermit.config';
import humanizeString from 'humanize-string';
import { MarriageExemptiConfig } from '../../config/marriageExemption.config';
import { useApplication } from '../provider';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

const getSrv = () => {
  return vappContainer.get<ApplicationFormPageService>(
    ApplicationFormPageService.displayName
  );
};
export interface IFormatAppDraftMethods extends IPluginMethodMap {
  formatAppDraft(args: any): any;
}

export interface CFormatAppDraftProps {}

export class FormatAppDraftService implements IAgentPlugin {
  readonly methods: IFormatAppDraftMethods;

  constructor() {
    this.methods = {
      formatAppDraft: this.formatAppDraft.bind(this),
    };
  }

  private getQuery(applicationNo: string) {
    const type = applicationNo?.split('-')?.[0];
    switch (type) {
      case 'NWP':
        return GET_NWP;
      case 'RWP':
        return GET_RWP;
      case 'NCSME':
        return GET_CSME;
      case 'CSMEV':
        return GET_CSME;
      case 'NMEC':
        return GET_MARRIAGE;
      default:
        return GET_APPLICATION;
    }
  }
  private fetchcl = async (src:any) => {
    const token = loginSrv()?.getToken();
    try {
      const response = await axios.get(src, {
        headers: {
          'Content-Type': 'application/json',
          Authentication: `${token}`,
        },
        responseType: 'arraybuffer',
      });
    
      const data = response.data;
      
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(new Blob([data]));
        reader.onload = () => {
          const res = reader.result + '';
          console.log("final_initdata", res);
          resolve(res);
        };
        reader.onerror = error => reject(error);
      });
    } catch (error) {
      console.error('Error:', error);
      // Handle error
    }

      
    
  }

  private async formatAppDraft(args: any) {
    const { applicationNo } = useApplication();
    console.log('ent->');

    // if(!applicationNo) return null;
    console.log('formatAppDraft draftData : : :', applicationNo);
    const storageService = StorageModule.getInstance();
    storageService.set('DRAFT_APP_ID', applicationNo, 'session');
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const whoAmI =
      userData?.currentRole ??
      (userData?.userRoles && Array.isArray(userData?.userRoles)
        ? userData?.userRoles[0]?.name
        : null);

    const query = this.getQuery(applicationNo!);
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client && applicationNo) {
        const res = await client.query(query, {
          applicationNo: applicationNo,
        });

        if (res?.data?.getApplication) {
          if (
            res?.data?.getApplication?.status !== 'APPLICATION_INCOMPLETE' &&
            res?.data?.getApplication?.status !== 'APPLICANT_DRAFT' &&
            res?.data?.getApplication?.status !== 'MISSING_INFORMATION'
          ) {
            return null;
          }
          console.log(
            'formatAppDraft draftData #1:: drafted',
            res?.data?.getApplication
          );
          const _variables = this._getVariables(
            res?.data?.getApplication,
            whoAmI
          );

          console.log('formatAppDraft draftData :: drafted', _variables);
          return _variables;
        }
      }
    } catch (err: any) {
      console.log(`error in getting application info`, err);
    }
  }

  private decodeBase64 = (s: string) => {
    try {
      return [
        {
          base64: atob(s),
        },
      ];
    } catch (err) {
      console.log('decodeBase64 error', s, err);
      return [
        {
          base64: s,
        },
      ];
    }
  };

  private getEmploymentInfo(empStatus: any, fullData: any) {
    console.log('stu->', fullData?.studentEducationDetail);
    if (empStatus === 'STUDENT') {
      const student = fullData?.studentEducationDetail;
      console.log('stu->', student);
      return {
        employmentStatus: empStatus,
        educationType:
          student?.educationType === 'Academic degree programme' ||
          student?.educationType === 'Vocational training'
            ? student?.educationType
            : student?.educationType
            ? 'others'
            : undefined,
        educationTypeOthers:
          student?.educationType !== 'Academic degree programme' &&
          student?.educationType !== 'Vocational training'
            ? student?.educationType
            : undefined,

        degree: student?.degreeOrCertificate,
        studentTelephone: student?.primaryContactNo,
        studentEmailAddress: student?.email,
        institutionName: student?.instituteName,
        institutionAddress: student?.instituteAddress?.addressLine1,
      };
    }
    return {};
  }

  private getEducationInfo(data: any, fullData: any) {
    console.log('qual->', data, fullData);
    if (Array.isArray(data) && data?.length > 0) {
      const qualifications = data?.map((qualification: any) => {
        console.log('qual->', qualification);
        return {
          dateOfQualification: qualification?.dateReceived,
          qualificationName: `${qualification?.degree}`,
          id: `${qualification?.institute}${qualification?.address?.addressLine1}${qualification?.dateReceived}`,
          name: qualification?.institute,
          address1: qualification?.address?.addressLine1,
          address2: qualification?.address?.addressLine2,
          city: qualification?.address?.city,
          parish: qualification?.address?.parish,
          country: qualification?.address?.country,
        };
      });
      let qualType =
        fullData?.type === 'NEW_WORK_PERMIT' ||
        fullData?.type === 'RENEW_WORK_PERMIT'
          ? {}
          : { qualification: qualifications };
      console.log('qual->', qualType);
      return {
        ...qualType,
      };
    }
    return {};
  }

  //asdnjn
  private _getVariables = (data: any, whoAmI: string) => {
    console.log('formatAppDraft draftData data', data);
    console.log('testing->', data?.marriageInfo);
    try {
      let documents;
      if (
        data?.type == 'MARRIAGE_EXEMPTION' ||
        data?.type == 'RENEW_MARRIAGE_EXEMPTION'
      ) {
        let docc = [
          ...(data?.documents ?? []),
          // ...(data?.marriageDocuments ?? []),
          // ...(data?.jamaicanDocuments ?? []),
        ];
        console.log('formatAppDraft getDocument -->2-->', data);
        documents = this.marrageExemptionDocuments(docc);

        // documents = this.get(data?.documents);
      } else {
        documents = this.getDocuments(data?.documents, data);
      }

      const _staffComposition = this.getStaffComposition(
        data?.employerInfo?.saffCompsition
      );
      console.log('formatAppDraft draftData _staffComposition', documents);
      let _initialData: any = {};
      let occupation = data?.applicantInfo?.occupation;
      console.log('occup->', occupation);
      if (whoAmI === 'prospective_employee') {
        console.log('imhere->', data);
        const highest = [
          'diplomaSecondary',
          'caribbeanVocationalQualification',
          'diplomaTertiary',
          'associateDegree',
          'universityDegree',
          'masterDegree',
          'masterOfPhilosophy',
          'doctorOfPhilosophy',
          'others',
        ];
        const nameChange: any = {
          deedPoll: 'deedpoll',
          marriage: '2',
          divorce: '3',
          otherDocuments: 'other',
        };
        _initialData = {

          ...documents,
          documents : data?.documents,
          status: data?.status,

          applicationNo: data?.applicationNo,
          qualification: this.getQualification(
            data?.applicantInfo?.qualification
          ),
          ...this.getEducationInfo(data?.applicantInfo?.qualification, data),
          ...this.getEmploymentInfo(
            data?.applicantInfo?.employmentStatus,
            data
          ),
          isHusbandWifeWorkedInJamaica: data?.applicantInfo
            ?.spouseWorkedInJamaica
            ? 'yes'
            : 'no',
          refusedvisadetail: this.getRefuseVisaDetail(data) ?? undefined,
          ...this.getDependentInfo(
            data?.dependentInfo ?? data?.applicantInfo?.dependentInfo
          ),
          type: data?.type,
          selfAddress1:
            data?.applicantInfo?.employmentStatus === 'SELF_EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.addressLine1
              : undefined,
          selfAddress2:
            data?.applicantInfo?.employmentStatus === 'SELF_EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.addressLine2
              : undefined,
          selfCity:
            data?.applicantInfo?.employmentStatus === 'SELF_EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.city
              : undefined,
          selfParish:
            data?.applicantInfo?.employmentStatus === 'SELF_EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.parish
              : undefined,
          selfCountry:
            data?.applicantInfo?.employmentStatus === 'SELF_EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.country
              : undefined,
          selfOccupation:
            data?.applicantInfo?.employmentStatus === 'SELF_EMPLOYED'
              ? data?.applicantInfo?.occupation
              : undefined,
          employedAddress1:
            data?.applicantInfo?.employmentStatus === 'EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.addressLine1
              : undefined,
          employedAddress2:
            data?.applicantInfo?.employmentStatus === 'EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.addressLine2
              : undefined,
          employedCity:
            data?.applicantInfo?.employmentStatus === 'EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.city
              : undefined,
          employedParish:
            data?.applicantInfo?.employmentStatus === 'EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.parish
              : undefined,
          employedCountry:
            data?.applicantInfo?.employmentStatus === 'EMPLOYED'
              ? data?.applicantInfo?.employmentAddress?.country
              : undefined,
          otherNationality: data?.applicantInfo?.otherNationality ?? undefined,
          passportIssuanceDate:
            data?.applicantInfo?.passportIssuanceDate ?? undefined,
          applicant: data?.applicant ?? undefined,

          employmentStatus: data?.applicantInfo?.employmentStatus,
          userEmail: data?.applicantInfo?.email ?? undefined,
          employedEmailAddress: data?.employerInfo?.email ?? undefined,
          employedNatureOfBusiness:
            data?.employerInfo?.natureOfBusiness?.includes(':')
              ? data?.employerInfo?.natureOfBusiness?.split(':')?.[1]
              : data?.employerInfo?.natureOfBusiness ?? undefined,
          employedTelephone: data?.employerInfo?.primaryContactNo ?? undefined,
          employerName: data?.employerInfo?.name ?? undefined,
          userTelephoneNumber:
            data?.applicantInfo?.primaryContactNo ?? undefined,
          expaddress1: data?.applicantInfo?.address?.addressLine1 ?? undefined,

          expPhoneNumber: data?.applicantInfo?.primaryContactNo ?? undefined,
          dateOfApplication:
            data?.certificateInfo?.dateOfApplication ?? undefined,
          issuanceDate: data?.certificateInfo?.issuanceDate ?? undefined,
          issuingAutority: data?.certificateInfo?.issuingAutority ?? undefined,
          credentialNo: data?.certificateInfo?.credentialNo ?? undefined,
          firstName: data?.applicantInfo?.firstName ?? undefined,
          lastName: data?.applicantInfo?.lastName ?? undefined,
          middleName: data?.applicantInfo?.middleName ?? undefined,
          dateOfEntry: data?.applicantInfo?.dateOfEntry ?? undefined,
          portOfEntry: data?.applicantInfo?.portOfEntry ?? undefined,
          expatriateTrn: data?.applicantInfo?.trn ?? undefined,
          maidenName: data?.applicantInfo?.maidenName ?? undefined,
          middleInitial: data?.applicantInfo?.middleName ?? undefined,
          nationality: data?.applicantInfo?.nationality,
          occupation: occupation,
          expOccupation: data?.applicantInfo?.occupation,
          address1: data?.applicantInfo?.address?.addressLine1 ?? null,
          address2: data?.applicantInfo?.address?.addressLine2 ?? null,
          streetaddress1: data?.applicantInfo?.address?.addressLine1 ?? null,
          streetaddress2: data?.applicantInfo?.address?.addressLine2 ?? null,
          city: data?.applicantInfo?.address?.city ?? null,
          country: data?.applicantInfo?.address?.country ?? null,
          parish: data?.applicantInfo?.address?.parish ?? null,
          postalCode: data?.applicantInfo?.address?.zipcode ?? null,
          userEmail2: data?.applicantInfo?.email ?? null,
          expEmail: data?.applicantInfo?.email ?? null,
          highEducationQualification: highest.includes(
            data?.applicantInfo?.highestQualification ?? ''
          )
            ? data?.applicantInfo?.highestQualification
            : 'others',
            highEducationQualificationOthers:
            data?.applicantInfo?.highestQualification ?? null,
            alias: data?.applicantInfo?.alias ?? null,
            previouslyMarried:
            data?.applicantInfo?.previouslyMarried === true ? 'yes' : 'no',
            isLegalNameChange:data?.applicantInfo?.isNameChange === true ?  'yes' : 'no',
            refusedVisaJamaica:
            data?.applicantInfo?.refusedJamaicanVisa === true ? 'yes' : 'no',
            refusedVisa:
            data?.applicantInfo?.refusedVisaOrDenied === true ? 'yes' : 'no',
            criminalConvictions:
            data?.applicantInfo?.criminalActivity === true ? 'yes' : 'no',
            currentlyEmployed:
            data?.applicantInfo?.employed === true ? 'yes' : 'no',
            finCapable:
            data?.applicantInfo?.financiallyCapable === true ? 'yes' : 'no',
            isNameChange:
            data?.applicantInfo?.isNameChange === true ? 'yes' : 'no',
            nameChangeDocType:data?.applicantInfo?.nameChangeDocType,
            isNameSupport: data?.applicantInfo?.nameChangeDocType,
            nameChangeType: data?.applicantInfo?.nameChangeDocType
            ? nameChange?.[data?.applicantInfo?.nameChangeDocType]
            : null,
            _firstName: data?.applicantInfo?.firstName,
            _lastName: data?.applicantInfo?.lastName,
            _middleInitial: data?.applicantInfo?.middleName,
            _nationality: data?.applicantInfo?.nationality,
            _occupation: occupation,
            isMailingAddressSame: data?.applicantInfo?.isMailingAddressSame
            ? 'yes'
            : 'no',
            isFirstNameChange: data?.applicantInfo?.isFirstNameChange
            ? 'yes'
            : 'no',
            isLastNameChange: data?.applicantInfo?.isLastNameChange
            ? 'yes'
            : 'no',
            isMiddleNameChange: data?.applicantInfo?.isMiddleNameChange
            ? 'yes'
            : 'no',
            isOccupationChange: data?.applicantInfo?.isOccupationChange
            ? 'yes'
            : 'no',
          isNationalityChange: data?.applicantInfo?.isNationalityChange
            ? 'yes'
            : 'no',
          isPassportExpired: data?.applicantInfo?.isPassportExpired
          ? 'yes'
          : 'no',
          isDependentExist: data?.applicantInfo?.isDependentExist
            ? 'yes'
            : 'no',
            
          noOfChildren: data?.applicantInfo?.childrenOrDependent
            ? data?.applicantInfo?.childrenOrDependent.toString()
            : '0',
            destinationCarribbeanState:
            data?.applicantInfo?.destinationCarribbeanState ?? undefined,
            natureOfProfessionalActivity:
            data?.applicantInfo?.natureOfProfessionalActivity ?? undefined,
            dateOfBirth: data?.applicantInfo?.dateOfBirth ?? null,
            gender: data?.applicantInfo?.gender ?? null,
            isLastNameExist:
            data?.applicantInfo?.isLastNameExist == true ? 'yes' : 'no',
            countryConvicted: data?.applicantInfo?.countryConvicted ?? null,
            dateOfConviction: data?.applicantInfo?.dateOfConviction ?? null,
            natureOfOffence: data?.applicantInfo?.natureOfOffence ?? null,
            jamaicanLastName: data?.jamaicanInfo?.lastName ?? null,
            jamaicanFirstName: data?.jamaicanInfo?.firstName ?? null,
            jamaicanMiddleName: data?.jamaicanInfo?.middleName ?? null,
            jamaicanMaidenName: data?.jamaicanInfo?.maidenName ?? null,
            jamaicanPlaceOfBirth: data?.jamaicanInfo?.placeOfBirth ?? null,
          jamaicanNationality: data?.jamaicanInfo?.nationality ?? null,
          typeOfIndentification:
            data?.jamaicanInfo?.typeOfIdentification ?? null,
          jamaicanDateOfBirth: data?.jamaicanInfo?.dateOfBirth ?? null,
          jamaicanTrn: data?.jamaicanInfo?.trn ?? null,
          jamaicanSex: data?.jamaicanInfo?.gender ?? null,
          jamaicanNIS: data?.jamaicanInfo?.NIS ?? null,
          jamaicanEmployedState:
            data?.jamaicanInfo?.jamaicanEmployedState ?? null,
            jamaicanPreviouslyMarried:
            data?.jamaicanInfo?.previouslyMarried === true ? 'yes' : 'no',
            jamaicanDivorcedOrWidowed:
            data?.jamaicanInfo?.divorceOrWidowed ?? null,
            addressOfEmployer:
            data?.jamaicanInfo?.addressOfEmployer?.addressLine1 ?? null,
            jamaincaSpouseLiving:
            data?.jamaicanInfo?.jamaincaSpouseLiving ?? null,
            // birthNaturalizationCertificateNo : data?.jamaicanInfo?.birthNaturalizationCertificateNo ?? null,
            citizenshipProof: data?.jamaicanInfo?.citizenshipProof ?? null,
          birthCertificateNo: data?.jamaicanInfo?.birthCertificateNo ?? null,
          naturalizationCertificateNo:
          data?.jamaicanInfo?.NaturalizationCertificateNo ?? null,
          jamaicanCurrentlyEmployed:
            data?.jamaicanInfo?.employed === true ? 'yes' : 'no',
            jamaicanMonthlySalary: data?.jamaicanInfo?.salary ?? null,
            jamaicanOtherIncome: data?.jamaicanInfo?.otherIncomeSource ?? null,
          jamaicanEmailAddress: data?.jamaicanInfo?.email ?? null,
          jamaicanContactNumber: data?.jamaicanInfo?.primaryContactNo ?? null,
          jamaicanFinCapable:
            data?.jamaicanInfo?.financiallyCapable === true ? 'yes' : 'no',
          jamaicanOccupation: data?.jamaicanInfo?.occupation ?? null,
          jamaicanaddress1: data?.jamaicanInfo?.address?.addressLine1 ?? null,
          jamaicancity: data?.jamaicanInfo?.address?.city ?? null,
          jamaicanparish: data?.jamaicanInfo?.address?.parish ?? null,
          marriageOfficerName: data?.marriageInfo?.nameOfOfficer ?? null,
          groomsName: data?.marriageInfo?.groomName ?? null,
          bridesName: data?.marriageInfo?.brideName ?? null,
          placeOfMarriage: data?.marriageInfo?.placeOfMarriage ?? null,
          marriageCertificateNo:
          data?.marriageInfo?.marriageCertificateNo ?? null,
          dateOfMarriage: data?.marriageInfo?.dateOfMarriage ?? null,
          addressOfCouple:
          data?.marriageInfo?.addressOfCouple?.addressLine1 ?? null,
          coupleParish: data?.marriageInfo?.addressOfCouple?.parish ?? null,
          coupleCity: data?.marriageInfo?.addressOfCouple?.city ?? null,
          divorcedOrWidowed: data?.applicantInfo?.divorceOrWidowed ?? null,
          refusedVisaDetails:
          data?.applicantInfo?.refusedVisaOrDeniedReason ?? null,
          refusedVisaJamaicaReason:
          data?.applicantInfo?.refusedJamaicanVisaReason ?? null,
          ifCriminalConviction:
          data?.applicantInfo?.criminalActivityReason ?? null,
          monthlySalary: data?.applicantInfo?.salary,
          criminalOffence:
          data?.applicantInfo?.criminalOffence === true ? 'yes' : 'no',
          employerAddress1:
          data?.applicantInfo?.lastEmployer?.address?.addressLine1 ?? null,
          employerAddress2:
            data?.applicantInfo?.lastEmployer?.address?.addressLine2 ?? null,
            employerCity:
            data?.applicantInfo?.lastEmployer?.address?.city ?? null,
            
            employerParish:
            data?.applicantInfo?.lastEmployer?.address?.parish ?? null,
            jamaicanEmployerName: data?.jamaicanInfo?.nameOfEmployer ?? undefined,
            
            nameOfEmployer: data?.applicantInfo?.lastEmployer?.name ?? undefined,
            purposeOfRelocation:
            data?.applicantInfo?.purposeOfRelocation ?? undefined,
            employmentOccupation: data?.applicantInfo?.employmentOccupation,
            
          telephoneOfEmployer:
            data?.applicantInfo?.lastEmployer?.primaryContactNo ?? null,
          trn: data?.applicantInfo?.trn ?? null,
          workPermitNumber:
            data?.applicantInfo?.lastEmployer?.credentialNo ?? null,
          workPermitExpiry: data?.applicantInfo?.lastEmployer?.wpExpiry ?? null,
          maritalStatus: data?.applicantInfo?.maritalStatus ?? null,
          passportExpiry: data?.applicantInfo?.passportExpiry ?? null,
          passportExpiryDate: data?.applicantInfo?.passportExpiry ?? null,
          passport: data?.applicantInfo?.passportNumber ?? null,
          expPassportNo: data?.applicantInfo?.passportNumber ?? undefined,

          typeOfPassport: data?.applicantInfo?.passportType ?? null,
          permitPeriodStart:
            data?.applicantInfo?.permissionPeriod?.from ?? null,
          previousEmployment: data?.applicantInfo?.previousEmployment
            ? 'yes'
            : 'no',
          justifcationForForeignEmployee:
            data?.applicantInfo?.justifcationForForeignEmployee ?? null,
          permitPeriodEnd: data?.applicantInfo?.permissionPeriod?.to ?? null,
          placeOfBirth: data?.applicantInfo?.placeOfBirth ?? null,

          skills: data?.applicantInfo?.skills ?? null,
          employerAddress1Dep:
            data?.applicantInfo?.spouseLastEmployer?.address?.addressLine1 ??
            null,
          employerAddress2Dep:
            data?.applicantInfo?.spouseLastEmployer?.address?.addressLine2 ??
            null,
          employerCityDep:
            data?.applicantInfo?.spouseLastEmployer?.address?.city ?? null,
          employerParishDep:
            data?.applicantInfo?.spouseLastEmployer?.address?.parish ?? null,
          nameOfEmployerDep:
            data?.applicantInfo?.spouseLastEmployer?.name ?? null,
          workPermitNumberDep:
            data?.applicantInfo?.spouseLastEmployer?.credentialNo ?? null,
          workPermitExpiryDep:
            data?.applicantInfo?.spouseLastEmployer?.wpExpiry ?? null,
          telephoneOfHusbandWife:
            data?.applicantInfo?.spouseLastEmployer?.telephoneOfHusbandWife ??
            null,
          husbandOrWifeName: data?.applicantInfo?.spouseName ?? null,
          husbandOrWifeNationality:
            data?.applicantInfo?.spouseNationality ?? null,
          workExperience: this.getWorkExperience(data?.applicantInfo),
          userNatureOfBusiness:
            data?.applicantInfo?.natureOfBusiness ?? undefined,
          countryOfBirth: data?.applicantInfo?.countryOfBirth ?? undefined,

          workedInJamaica:
            data?.applicantInfo?.workedInJamaica === true ? 'yes' : 'no',
        };
      } else {
        _initialData = {
          documents : data?.documents,
          status: data?.status,
          applicationNo: data?.applicationNo,
          jamaicanProfessional: 0,
          jamaicanClerks: 0,
          jamaicanSkilledWorkers: 0,
          jamaicanPlant: 0,
          jamaicanElementary: 0,
          carricomProfessional: 0,
          carricomClerks: 0,
          carricomSkilledWorkers: 0,
          carricomPlant: 0,
          carricomElementary: 0,
          commonWealthProfessional: 0,
          commonWealthClerks: 0,
          commonWealthSkilledWorkers: 0,
          commonWealthPlant: 0,
          commonWealthElementary: 0,
          foreignProfessional: 0,
          foreignClerks: 0,
          foreignSkilledWorkers: 0,
          foreignPlant: 0,
          foreignElementary: 0,
          qualification: this.getQualification(
            data?.applicantInfo?.qualification
          ),
          ...documents,
          ..._staffComposition,
          ...this.getEducationInfo(data?.applicantInfo?.qualification, data),
          ...this.getEmploymentInfo(
            data?.applicantInfo?.employmentStatus,
            data
          ),
          ...this.getDependentInfo(
            data?.dependentInfo ?? data?.applicantInfo?.dependentInfo
          ),
          isNameSupport: data?.applicantInfo?.nameChangeDocType,
          type: data?.type,
          maidenName: data?.applicantInfo?.maidenName ?? undefined,
          applicant: data?.applicant ?? undefined,
          otherNationality: data?.applicantInfo?.otherNationality ?? undefined,
          passportIssuanceDate:
            data?.applicantInfo?.passportIssuanceDate ?? undefined,
          isHusbandWifeWorkedInJamaica: data?.applicantInfo
            ?.spouseWorkedInJamaica
            ? 'yes'
            : 'no',

          userEmail: data?.applicantInfo?.email ?? undefined,
          userTelephoneNumber:
            data?.applicantInfo?.primaryContactNo ?? undefined,
          telephoneContact: data?.applicantInfo?.primaryContactNo ?? undefined,
          destinationCarribbeanState:
            data?.applicantInfo?.destinationCarribbeanState ?? undefined,
          natureOfProfessionalActivity:
            data?.applicantInfo?.natureOfProfessionalActivity ?? undefined,
          _firstName: data?.applicantInfo?.firstName,
          _lastName: data?.applicantInfo?.lastName,
          _middleInitial: data?.applicantInfo?.middleName,
          _nationality: data?.applicantInfo?.nationality,
          _occupation: occupation,
          purposeOfRelocation:
            data?.applicantInfo?.purposeOfRelocation ?? undefined,
          countryOfBirth: data?.applicantInfo?.countryOfBirth ?? undefined,

          firstName: data?.applicantInfo?.firstName,
          lastName: data?.applicantInfo?.lastName,
          middleInitial: data?.applicantInfo?.middleName,
          nationality: data?.applicantInfo?.nationality,
          occupation: data?.applicantInfo?.occupation,
          employmentOccupation: data?.applicantInfo?.employmentOccupation,
          occupationalSkill: data?.applicantInfo?.skills,
          userEmail2: data?.applicantInfo?.email ?? null,
          highEducationQualificationOthers:
            data?.applicantInfo?.highEducationQualification ?? undefined,
          isNameChange: data?.applicantInfo?.isNameChange ? 'yes' : 'no',
          isMailingAddressSame: data?.applicantInfo?.isMailingAddressSame
            ? 'yes'
            : 'no',
          isFirstNameChange: data?.applicantInfo?.isFirstNameChange
            ? 'yes'
            : 'no',
          isLastNameChange: data?.applicantInfo?.isLastNameChange
            ? 'yes'
            : 'no',
          isMiddleNameChange: data?.applicantInfo?.isMiddleNameChange
            ? 'yes'
            : 'no',
          isOccupationChange: data?.applicantInfo?.isOccupationChange
            ? 'yes'
            : 'no',
          isNationalityChange: data?.applicantInfo?.isNationalityChange
            ? 'yes'
            : 'no',
          isPassportExpired: data?.applicantInfo?.isPassportExpired
            ? 'yes'
            : 'no',
          isDependentExist: data?.applicantInfo?.isDependentExist
            ? 'yes'
            : 'no',
          businessAddress1: data?.employerInfo?.address?.addressLine1 ?? null,
          businessAddress2: data?.employerInfo?.address?.addressLine2 ?? null,
          businessCity: data?.employerInfo?.address?.city ?? null,
          businessCountry: data?.employerInfo?.address?.country ?? null,
          businessParish: data?.employerInfo?.address?.parish ?? null,
          businessPostalCode: data?.employerInfo?.address?.zipcode ?? null,
          dateOfReg: data?.employerInfo?.dateOfRegistration ?? null,
          email: data?.employerInfo?.email ?? null,
          // userEmail : 'email@email.com',
          faxNumber: data?.employerInfo?.fax ?? null,
          businessName: data?.employerInfo?.name ?? null,
          natureOfBusiness: data?.employerInfo?.natureOfBusiness?.includes(':')
            ? data?.employerInfo?.natureOfBusiness?.split(':')?.[1]
            : data?.employerInfo?.natureOfBusiness ?? undefined,
          workPermit:
            data?.employerInfo?.workPermitIsInRelationTo === 'multilateral' ||
            data?.employerInfo?.workPermitIsInRelationTo === 'overseas'
              ? data?.employerInfo?.workPermitIsInRelationTo
              : 'others' ?? null,
          workPermitOthers:
            data?.employerInfo?.workPermitIsInRelationTo ?? null,
          mailingAddress1:
            data?.employerInfo?.operatingAddress?.addressLine1 ?? null,
          mailingAddress2:
            data?.employerInfo?.operatingAddress?.addressLine2 ?? null,
          mailingCity: data?.employerInfo?.operatingAddress?.city ?? null,
          mailingCountry: data?.employerInfo?.operatingAddress?.country ?? null,
          mailingParish: data?.employerInfo?.operatingAddress?.parish ?? null,
          mailingPostalCode:
            data?.employerInfo?.operatingAddress?.zipcode ?? null,
          telephoneNumber: data?.employerInfo?.primaryContactNo ?? null,
          noOfYearsWithCompany:
            parseInt(data?.applicantInfo?.noOfYearsWithCompany) ?? null,
          // totalStaff: data?.employerInfo?.totalStaff
          //   ? parseInt(data?.employerInfo?.totalStaff)
          //   : 0,
          tccExpiryDate: data?.employerInfo?.tccExpiryDate ?? null,
          tccNumber: data?.employerInfo?.tccNumber ?? null,
          businessTrn: data?.employerInfo?.trn ?? null,
          website: data?.employerInfo?.website ?? null,
          jobId: data?.jobInfo?.JobId ?? null,
          jobTitle: data?.jobInfo?.JobTitle ?? null,
          jobDuties: data?.jobInfo?.jobDuties ?? null,
          qualifications: data?.jobInfo?.necessaryQualification ?? null,
          qualificationName: data?.jobInfo?.necessaryQualification ?? null,
          car: data?.jobInfo?.allowances?.car,
          entertainment: data?.jobInfo?.allowances?.entertainment,
          house: data?.jobInfo?.allowances?.house,
          allowanceOther: data?.jobInfo?.allowances?.other,
          salaryOffered: data?.jobInfo?.salaryOffered,
          registeredLMIS: data?.jobInfo?.registeredLMIS === true ? 'yes' : 'no',
          workingHours: data?.jobInfo?.workingHours ?? null,
          benefitsReceived:
            data?.jobInfo?.benefitsReceived === true ? 'yes' : 'no',
          byAdvertisement:
            data?.jobInfo?.stepsForJaimacan?.byAdvertisement === true
              ? 'yes'
              : 'no',
          didJamaicanApply:
            data?.jobInfo?.stepsForJaimacan?.didJamaicanApply === true
              ? 'yes'
              : 'no',
          appliedCandidates:
            data?.jobInfo?.stepsForJaimacan?.appliedCandidates ?? 0,
          reasonNoneHired:
            data?.jobInfo?.stepsForJaimacan?.reasonNoneHired ?? null,
          noStepTaken: data?.jobInfo?.stepsForJaimacan?.noStepTaken ?? null,
          internalRecruitment:
            data?.jobInfo?.stepsForJaimacan?.internalRecruitment === true
              ? 'yes'
              : 'no',

          jamaicanaddress1: data?.jamaicanInfo?.address?.addressLine1 ?? null,
          jamaicancity: data?.jamaicanInfo?.address?.city ?? null,
          jamaicanparish: data?.jamaicanInfo?.address?.parish ?? null,

          //applicantInfo
          address1: data?.applicantInfo?.address?.addressLine1 ?? null,
          address2: data?.applicantInfo?.address?.addressLine2 ?? null,
          streetAddress1: data?.applicantInfo?.address?.addressLine1 ?? null,
          streetAddress2: data?.applicantInfo?.address?.addressLine2 ?? null,
          city: data?.applicantInfo?.address?.city ?? null,
          country: data?.applicantInfo?.address?.country ?? null,
          parish: data?.applicantInfo?.address?.parish ?? null,
          postalCode: data?.applicantInfo?.address?.zipcode ?? null,
          alias: data?.applicantInfo?.alias ?? null,
          noOfChildren: data?.applicantInfo?.childrenOrDependent
            ? data?.applicantInfo?.childrenOrDependent.toString()
            : '0',
          dateOfBirth: data?.applicantInfo?.dateOfBirth ?? null,
          gender: data?.applicantInfo?.gender ?? null,
          isLastNameExist:
            data?.applicantInfo?.isLastNameExist == true ? 'yes' : 'no',
          countryConvicted: data?.applicantInfo?.countryConvicted ?? null,
          dateOfConviction: data?.applicantInfo?.dateOfConviction ?? null,
          natureOfOffence: data?.applicantInfo?.natureOfOffence ?? null,
          criminalOffence:
            data?.applicantInfo?.criminalOffence === true ? 'yes' : 'no',
          employerAddress1:
            data?.applicantInfo?.lastEmployer?.address?.addressLine1 ?? null,
          employerAddress2:
            data?.applicantInfo?.lastEmployer?.address?.addressLine2 ?? null,
          employerCity:
            data?.applicantInfo?.lastEmployer?.address?.city ?? null,

          employerParish:
            data?.applicantInfo?.lastEmployer?.address?.parish ?? null,

          nameOfEmployer: data?.applicantInfo?.lastEmployer?.name ?? undefined,
          jamaicanEmployerName: data?.jamaicanInfo?.nameOfEmployer ?? undefined,

          telephoneOfEmployer:
            data?.applicantInfo?.lastEmployer?.primaryContactNo ?? null,
          trn: data?.applicantInfo?.trn ?? null,
          workPermitNumber:
            data?.applicantInfo?.lastEmployer?.credentialNo ?? null,
          workPermitExpiry: data?.applicantInfo?.lastEmployer?.wpExpiry ?? null,
          maritalStatus: data?.applicantInfo?.maritalStatus ?? null,
          userNatureOfBusiness:
            data?.applicantInfo?.natureOfBusiness ?? undefined,
          passportExpiry: data?.applicantInfo?.passportExpiry ?? null,
          passport: data?.applicantInfo?.passportNumber ?? null,
          passportNumber: data?.applicantInfo?.passportNumber ?? null,
          typeOfPassport: data?.applicantInfo?.passportType ?? null,
          permitPeriodStart:
            data?.applicantInfo?.permissionPeriod?.from ?? null,
          previousEmployment: data?.applicantInfo?.previousEmployment
            ? 'yes'
            : 'no',
          justifcationForForeignEmployee:
            data?.applicantInfo?.justifcationForForeignEmployee ?? null,
          permitPeriodEnd: data?.applicantInfo?.permissionPeriod?.to ?? null,
          placeOfBirth: data?.applicantInfo?.placeOfBirth ?? null,
          intendedStreetAddress1:
            data?.applicantInfo?.intendedAddress?.addressLine1 ?? null,
          intendedStreetAddress2:
            data?.applicantInfo?.intendedAddress?.addressLine2 ?? null,
          skills: data?.applicantInfo?.skills ?? null,
          employerAddress1Dep:
            data?.applicantInfo?.spouseLastEmployer?.address?.addressLine1 ??
            null,
          employerAddress2Dep:
            data?.applicantInfo?.spouseLastEmployer?.address?.addressLine2 ??
            null,
          employerCityDep:
            data?.applicantInfo?.spouseLastEmployer?.address?.city ?? null,
          employerParishDep:
            data?.applicantInfo?.spouseLastEmployer?.address?.parish ?? null,
          nameOfEmployerDep:
            data?.applicantInfo?.spouseLastEmployer?.name ?? null,
          workPermitNumberDep:
            data?.applicantInfo?.spouseLastEmployer?.credentialNo ?? null,
          workPermitExpiryDep:
            data?.applicantInfo?.spouseLastEmployer?.wpExpiry ?? null,
          telephoneOfHusbandWife:
            data?.applicantInfo?.spouseLastEmployer?.telephoneOfHusbandWife ??
            null,
          husbandOrWifeName: data?.applicantInfo?.spouseName ?? null,
          husbandOrWifeNationality:
            data?.applicantInfo?.spouseNationality ?? null,
          workExperience: this.getWorkExperience(data?.applicantInfo),

          workedInJamaica:
            data?.applicantInfo?.workedInJamaica === true ? 'yes' : 'no',
        };
      }
      console.log('formatAppDraft draftData _initialData', _initialData);
      return _initialData;
    } catch (err) {
      console.log('formatAppDraft draftData error', err);
    }
  };

  private getStaffComposition(data: any) {
    let _staffComposition: any = {};
    console.log('formatAppDraft getStaffComposition bla', data);
    try {
      data &&
        Array.isArray(data) &&
        data.length > 0 &&
        data.map((ele) => {
          console.log('formatAppDraft ele bla', ele);
          if (ele?.citizenship === 'JAMAICAN') {
            _staffComposition = {
              ..._staffComposition,
              jamaicanProfessional: ele?.professional ?? 0,
              jamaicanClerks: ele?.clerksOrServiceWorker ?? 0,
              jamaicanSkilledWorkers: ele?.skilledWorkers ?? 0,
              jamaicanPlant: ele?.plantAndMachineOperators ?? 0,
              jamaicanElementary: ele?.elementaryOccupations ?? 0,
            };
          } else if (ele?.citizenship === 'CARRICOM') {
            _staffComposition = {
              ..._staffComposition,
              carricomProfessional: ele?.professional ?? 0,
              carricomClerks: ele?.clerksOrServiceWorker ?? 0,
              carricomSkilledWorkers: ele?.skilledWorkers ?? 0,
              carricomPlant: ele?.plantAndMachineOperators ?? 0,
              carricomElementary: ele?.elementaryOccupations ?? 0,
            };
          } else if (ele?.citizenship === 'COMMON_WEALTH') {
            _staffComposition = {
              ..._staffComposition,
              commonWealthProfessional: ele?.professional ?? 0,
              commonWealthClerks: ele?.clerksOrServiceWorker ?? 0,
              commonWealthSkilledWorkers: ele?.skilledWorkers ?? 0,
              commonWealthPlant: ele?.plantAndMachineOperators ?? 0,
              commonWealthElementary: ele?.elementaryOccupations ?? 0,
            };
          } else if (ele?.citizenship === 'FOREGION') {
            _staffComposition = {
              ..._staffComposition,
              foreignProfessional: ele?.professional ?? 0,
              foreignClerks: ele?.clerksOrServiceWorker ?? 0,
              foreignSkilledWorkers: ele?.skilledWorkers ?? 0,
              foreignPlant: ele?.plantAndMachineOperators ?? 0,
              foreignElementary: ele?.elementaryOccupations ?? 0,
            };
          }
        });
      console.log(
        'formatAppDraft _staffComposition bla : :',
        _staffComposition
      );
      return _staffComposition;
    } catch (err) {}
  }
  private mrgdoc:any = [];
  private getDocuments(data: any, formData: any) {
    console.log("getD-coument",data);
    let _documents: any = {};
    let docss : any = {nolGender: 'EMPLOYMENT_NO_OBJECTION_CERTIFICATE',
    nolSports: 'EMPLOYMENT_NO_OBJECTION_CERTIFICATE',
    nolMusic: 'EMPLOYMENT_NO_OBJECTION_CERTIFICATE',
    nolMedia: 'EMPLOYMENT_NO_OBJECTION_CERTIFICATE',
    graduateQual: 'EMPLOYMENT_QUALIFICATION_CERTIFICATE',
    nurseQual: 'EMPLOYMENT_QUALIFICATION_CERTIFICATE',
    associateDegreeQual: 'EMPLOYMENT_QUALIFICATION_CERTIFICATE',
    teacherQual: 'EMPLOYMENT_QUALIFICATION_CERTIFICATE'}
    let docData: any = {...workPermitConfig?.availableDocuments,...docss};
    console.log("adsfadsf",workPermitConfig?.availableDocuments)
    const csmeDocData = [
      {
        id: 'employmentOccupation',
        payload: 'Graduates',
        newItem: 'graduateQual',
      },
      { id: 'employmentOccupation', payload: 'Artiste', newItem: 'nolGender' },
      { id: 'employmentOccupation', payload: 'Musicians', newItem: 'nolMusic' },
      {
        id: 'employmentOccupation',
        payload: 'Sport_Persons',
        newItem: 'nolSports',
      },
      {
        id: 'employmentOccupation',
        payload: 'Media_Workers',
        newItem: 'nolMedia',
      },
      { id: 'employmentOccupation', payload: 'Nurses', newItem: 'nurseQual' },
      {
        id: 'employmentOccupation',
        payload: 'Teachers',
        newItem: 'teacherQual',
      },
      {
        id: 'employmentOccupation',
        payload: 'Holders_of_Associate_Degree',
        newItem: 'associateDegreeQual',
      },
      { id: 'employmentOccupation', payload: 'Nurses', newItem: 'nurseQual' },
    ];

    console.log('dataoc->', docData, formData?.applicantInfo);
    csmeDocData?.forEach((ele) => {
      if (formData?.applicantInfo?.[ele?.id] !== ele?.payload) {
        console.log(
          'hg->',
          ele?.id,
          formData?.applicantInfo?.[ele?.id],
          ele?.payload
        );
        docData[ele?.newItem] = undefined;
      }
    });
    console.log('dataoc->', docData);
    try {
      docData &&
        Object.entries(docData)
          .filter((item) => item[1])
          .forEach((ele, index) => {
            let _similarDoc: any[] = [];
            data &&
              Array.isArray(data) &&
              data.length > 0 &&
              data.map((doc: any) => {
                console.log('docii->', ele[0], ele[1], doc?.type);
                if (doc?.type === ele[1]) {
                  _similarDoc.push({
                    name: doc?.name,
                    src:doc?.src,
                    type: doc?.fileType,
                  });
                }
              });
            _documents[ele[0]] = _similarDoc;
            console.log('doci->', _similarDoc, ele[0], ele[1]);
          });
      console.log('formatAppDraft getDocuments ', _documents);
      console.log("getD-coument--after",_documents);
    } catch (err) {
      console.log('formatAppDraft getDocuments error', err);
    }
    return _documents;
  }
  private getdepDocuments(data: any, formData: any) {
    console.log("getD-coument",data);
    let _documents: any = {};
    let docss : any = {nolGender: 'EMPLOYMENT_NO_OBJECTION_CERTIFICATE',
    nolSports: 'EMPLOYMENT_NO_OBJECTION_CERTIFICATE',
    nolMusic: 'EMPLOYMENT_NO_OBJECTION_CERTIFICATE',
    nolMedia: 'EMPLOYMENT_NO_OBJECTION_CERTIFICATE',
    graduateQual: 'EMPLOYMENT_QUALIFICATION_CERTIFICATE',
    nurseQual: 'EMPLOYMENT_QUALIFICATION_CERTIFICATE',
    associateDegreeQual: 'EMPLOYMENT_QUALIFICATION_CERTIFICATE',
    teacherQual: 'EMPLOYMENT_QUALIFICATION_CERTIFICATE'}
    let docData: any = {...workPermitConfig?.availableDocuments,...docss};
    console.log("adsfadsf",workPermitConfig?.availableDocuments)
    const csmeDocData = [
      {
        id: 'employmentOccupation',
        payload: 'Graduates',
        newItem: 'graduateQual',
      },
      { id: 'employmentOccupation', payload: 'Artiste', newItem: 'nolGender' },
      { id: 'employmentOccupation', payload: 'Musicians', newItem: 'nolMusic' },
      {
        id: 'employmentOccupation',
        payload: 'Sport_Persons',
        newItem: 'nolSports',
      },
      {
        id: 'employmentOccupation',
        payload: 'Media_Workers',
        newItem: 'nolMedia',
      },
      { id: 'employmentOccupation', payload: 'Nurses', newItem: 'nurseQual' },
      {
        id: 'employmentOccupation',
        payload: 'Teachers',
        newItem: 'teacherQual',
      },
      {
        id: 'employmentOccupation',
        payload: 'Holders_of_Associate_Degree',
        newItem: 'associateDegreeQual',
      },
      { id: 'employmentOccupation', payload: 'Nurses', newItem: 'nurseQual' },
    ];

    console.log('dataoc->', docData, formData?.applicantInfo);
    csmeDocData?.forEach((ele) => {
      if (formData?.applicantInfo?.[ele?.id] !== ele?.payload) {
        console.log(
          'hg->',
          ele?.id,
          formData?.applicantInfo?.[ele?.id],
          ele?.payload
        );
        docData[ele?.newItem] = undefined;
      }
    });
    console.log('dataoc->', docData);
    try {
      docData &&
        Object.entries(docData)
          .filter((item) => item[1])
          .forEach((ele, index) => {
            let _similarDoc: any[] = [];
            data &&
              Array.isArray(data) &&
              data.length > 0 &&
              data.map(async (doc: any) => {
                console.log('docii->', ele[0], ele[1], doc?.type);
                if (doc?.type === ele[1]) {
                  _similarDoc.push({
                    name: doc?.name,
                    src:await this.fetchcl(doc?.src),
                    type: doc?.fileType,
                  });
                }
              });
            _documents[ele[0]] = _similarDoc;
            console.log('doci->', _similarDoc, ele[0], ele[1]);
          });
      console.log('formatAppDraft getDocuments ', _documents);
      console.log("getD-coument--after",_documents);
    } catch (err) {
      console.log('formatAppDraft getDocuments error', err);
    }
    return _documents;
  }
  private marrageExemptionDocuments(data: any) {
    console.log('entered...');
    console.log('formatAppDraft getDocument --->1--->', data);
    let _documents: any = {};
    try {
      MarriageExemptiConfig?.availableDocuments &&
        Object.entries(MarriageExemptiConfig?.availableDocuments).forEach(
          (ele, index) => {
            console.log('jramcheck->1', ele);
            let _similarDoc: any[] = [];
            console.log('jeyaramfinal->', data, data.length);
            data &&
              Array.isArray(data) &&
              data.length > 0 &&
              data.map((doc: any) => {
                console.log('jramcheck->2->', doc);
                if (doc?.type === ele[1]) {
                  _similarDoc.push({
                    name: doc?.name,
                    src: doc?.src,
                    type: doc?.fileType,
                  });
                }
              });
            _documents[ele[0]] = _similarDoc;
          }
        );
      console.log('formatAppDraft getDocuments ', _documents);
    } catch (err) {
      console.log('formatAppDraft getDocuments error', err);
    }
    // this.mrgdoc = Promise.all(_documents).then((res:any) => console.log("nzcxvzxcm",res)).catch(err=> console.log("nzcxvzxcm",err));
    
    return _documents;
  }
  private getRefuseVisaDetail(data: any) {
    let refuseVisa: any[] = [];
    data &&
      Array.isArray(data?.applicantInfo?.refusionDetail) &&
      data?.applicantInfo?.refusionDetail?.length > 0 &&
      data?.applicantInfo?.refusionDetail.forEach((ele: any) => {
        refuseVisa.push({
          id: `${ele?.country}${ele?.reason}`,
          refusedVisaCountry: ele?.country,
          refusedVisaReason: ele?.reason,
        });
      });
    return refuseVisa;
  }
  private getDependentInfo(data: any) {
    let _dependentInfo: any[] = [];
    console.log(`workPermitApp service getDependentInfo`, data);
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.forEach((ele: any) => {
        _dependentInfo.push({
          ...this.getdepDocuments(ele?.documents, data),
          dependentType: ele?.dependentType,
          dependentName: ele?.name,
          dependentRelationship: ele?.relationship,
          dependentPassport: ele?.passportNumber,
          dependentSex: ele?.gender,
          dependentNationality: ele?.nationality,
          dependentAge:
            typeof ele?.age === 'number' ? ele?.age?.toString() : ele?.age,
        });
      });
    return {
      dependentInfo: _dependentInfo,
      dependents: _dependentInfo.length > 0 ? 'yes' : undefined,
    };
  }

  private getWorkExperience(data: any) {
    let _workExperience: any[] = [];
    console.log(
      `workPermitApp service getWorkExperience`,
      data?.workExperience
    );
    data &&
      Array.isArray(data?.workExperience) &&
      data?.workExperience.length > 0 &&
      data?.workExperience.forEach((ele: any) => {
        _workExperience.push({
          wePeriodStart: ele?.from,
          wePeriodEnd: ele?.to,
          jobDutyType: ele?.jobDuty,
          organizationName: ele?.nameOfOrganization,
        });
      });
    return _workExperience;
  }

  private getQualification(data: any) {
    let _qualification: any[] = [];
    console.log(`workPermitApp service getQualification`, data);
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.forEach((ele: any, key: number) => {
        _qualification.push({
          qualificationName: ele?.degree,
          dateOfQualification: ele?.dateReceived,
          id: `${ele?.degree}-${ele?.dateReceived}-${key}`,
        });
      });
    return _qualification;
  }
}
